import { Injectable, inject } from '@angular/core';

import { EventMediaTracking } from '@frontend/sports/betting-offer/feature/media';
import { NOT_APPLICABLE, TrackData, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

@Injectable({
    providedIn: 'root',
})
export class EventMediaTrackingService {
    private trackingService = inject(TrackingService);

    track(eventDetails: string, tracking: EventMediaTracking): void {
        const baseTracking: TrackData = {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'sports',
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'media',
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'click',
            [trackingConstants.COMPONENT_POSITION_EVENT]: tracking.name ?? NOT_APPLICABLE,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: tracking.source ?? NOT_APPLICABLE,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: eventDetails,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_CONTENT_POSITION]: tracking.position?.toString() ?? NOT_APPLICABLE,
        };

        this.trackingService.track(trackingConstants.EVENT_TRACKING, {
            ...baseTracking,
            ...tracking?.additional,
        });
    }
}
